<template>
  <div class="hpanel forum-box">

    <div class="panel-heading">
      Mailing(s)
      <div class="pull-right text-right" v-if="question && !$auth.check('seeker')">
        <div class="btn-group">
          <router-link v-if="question.mailing.length !== 0" :to="{name: 'Mailing', params: {question_id: questionId, project_id: projectId}}" class="btn info btn-xs btn-info"><i class="fa fa-plus"></i> New mailing</router-link>
        </div>
      </div>

    </div>

    <template v-if="question !== null"  >
      <div class="panel-body" v-for="(mailing, key) in question.mailing" :key="key" v-if="(mailing.sent === null && !$auth.check('seeker')) || (mailing.sent !== null)">
        <div class="row">
          <div class="col-md-5 col-xs-12 forum-heading">
            <template v-if="mailing.sent === null">
              <span class="label label-warning pull-left">Draft</span>
              <router-link :to="{name: 'Mailing', params : {question_id: question.id, mailing_id: mailing.id}}">
                <h4 v-if="mailing.template">{{mailing.template.subject}}</h4>
                <h4 v-else>{{mailing.subject}}</h4>
              </router-link>
            </template>
            <template v-else>
              <span class="label label-success pull-left">Sent</span>
              <router-link :to="{name: 'MailingOverview', params : {mailing_id: mailing.id}}">
                <h4 v-if="mailing.template">{{mailing.template.subject}}</h4>
                <h4 v-else>{{mailing.subject}}</h4>
              </router-link>
            </template>
            <div style="margin-top: 10px" class="desc hidden-xs hidden-sm" v-html="mailing.created_at"></div>

          </div>
          <div class="col-md-5 col-xs-8 text-center vertical-align" style="font-size: 15px;height: 50px">
            <div class="col-xs-2">
              <span title="sent mails"><i style="" class="fa fa-send"></i> {{mailingEvent(mailing.id, 'sent')}}</span>
            </div>
            <div class="col-xs-2">
              <span title="Opened"><i class="fa fa-envelope-open"></i> {{mailingEvent(mailing.id, 'open')}}</span>
            </div>
            <div class="col-xs-2">
              <span title="Clicked"><i class="fa fa-hand-o-down"></i> {{mailingEvent(mailing.id, 'click')}}</span>
            </div>
            <div class="col-xs-2">
              <span title="Bounced"><i class="fa fa-undo"></i> {{mailingEvent(mailing.id, 'bounce')}}</span>
            </div>
            <div class="col-xs-2">
              <span title="Spam"><i class="fa fa-exclamation-circle"></i> {{mailingEvent(mailing.id, 'spam')}}</span>
            </div>

          </div>

          <div class="col-md-2 col-xs-4 forum-info">
            <span class="number"> {{mailing.authors.length}}</span>
            <small>Contacted experts</small>
          </div>
          <div class="col-xs-12 hidden-md hidden-lg">
            <div style="margin-top: 10px" class="desc" v-html="mailing.created_at"></div>
          </div>
        </div>
      </div>
    </template>
    <div class="panel-body" v-if="question === null || question.mailing.length === 0">
      <div class="row">
        <div class="col-xs-12 forum-heading text-center">
          <template v-if="!$auth.check('seeker')">
            <router-link :to="{name: 'Mailing', params: {question_id: questionId, project_id: projectId}}" class="btn btn-info">New mailing</router-link>
          </template>
          <template v-else>
            <div>
              <span>Mailing List Empty</span>
            </div>
            <div>
              <small>You can't create a mailing, only a broker can create and send a mailing</small>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  name: 'QuestionMailingOverview',
  props: ['questionId', 'projectId'],
  data () {
    return {
      question: null
    }
  },
  watch: {
    questionId: function (val) {
      if (this.questionId !== null) {
        this.getResources()
      }
    }
  },
  computed: {
  },
  methods: {
    getResources: function () {
      if (this.questionId !== null) {
        this.axios.get('/question/' + this.questionId)
          .then((response) => {
            this.question = response.data
          })
          .catch(function (error) {
          })
      }
    },
    mailingEvent: function (mailingId, eventName) {
      let mailing = this.question.mailing.find((item) => {
        return item.id === mailingId
      })

      let event = mailing.mailing_events.find((item) => {
        return item.event === eventName
      })

      return typeof event === 'undefined' ? 0 : event.nb_event
    }
  },
  beforeMount () {
    if (this.questionId !== null) {
      this.getResources()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionMailingOverview.vue